export const authConstants = {
    LOGIN_REQUEST: "LOGIN_REQUEST",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_FAILURE: "LOGIN_FAILURE",
    LOGOUT: "LOGOUT",
    RESTORE: "RESTORE",
    CHANGE_PROFILE: "CHANGE_PROFILE",
}

export const menuConstants = {
    MENU_REQUEST: 'MENU_REQUEST',
    MENU_SUCCESS: 'MENU_SUCCESS',
    MENU_FAILURE: 'MENU_FAILURE',
}

export const moduleConstants = {
    SAVE_MODULE: 'SAVE_MODULE',
    // MODULE_SUCCESS: 'MODULE_SUCCESS',
    MODULE_FAILURE: 'MODULE_FAILURE',
}
